import { Empty, Flex, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"

import AlertStatusTag from "../../../AlertsPage/components/AlertStatusTag/AlertStatusTag"
import { AlertDate, AlertSource, Amount, Card, Customer, TransactionId } from "./fields"

import styles from "../../styles.module.less"

const { Text } = Typography

const Field = ({ label, children }) => (
  <div className={styles.alertCardField}>
    <Text type="secondary" strong ellipsis>
      {label}
    </Text>
    {children}
  </div>
)

const AlertCard = ({ alert, theme, isDemo, onOpen }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={16} className={styles.alertCard} onClick={() => onOpen(alert)}>
      <Flex align="center" justify="space-between" gap={12}>
        <AlertSource alert={alert} theme={theme} />
        <AlertDate alert={alert} />
      </Flex>

      <Field label={t("Customer")}>
        <Customer alert={alert} />
      </Field>

      <div className={styles.alertCardGrid}>
        <Field label={t("Transaction ID")}>
          <TransactionId alert={alert} />
        </Field>
        <Field label={t("Amount")}>
          <Amount alert={alert} />
        </Field>
        <Field label={t("Card")}>
          <Card alert={alert} theme={theme} />
        </Field>
      </div>

      <AlertStatusTag alert={alert} disabledStatus isDemo={isDemo} />
    </Flex>
  )
}

// The mobile face of the block: the table's seven columns as stacked cards, because the row needs
// ~1175px and the page must never scroll sideways.
const AlertsCards = ({ alerts, loading, theme, isDemo, onOpen }) => (
  <Spin spinning={loading}>
    {alerts?.length ? (
      <Flex vertical gap={12}>
        {alerts.map((alert) => (
          <AlertCard
            key={alert.alert_id}
            alert={alert}
            theme={theme}
            isDemo={isDemo}
            onOpen={onOpen}
          />
        ))}
      </Flex>
    ) : (
      <Empty />
    )}
  </Spin>
)

export default AlertsCards
